Object.defineProperty(exports, "__esModule", { value: true })
exports.API_URL = void 0
exports.API_URL = "http://localhost:9100/"
